import IMG_LOGO from 'images/darkTheme/logo.svg';

const images = {
	IMG_LOGO
};

export default images;
